// @flow
import bisect from "binary-search";
import * as Types from "./NextGenChartTypes";

export default function discountinuousScale(
  checkpoints: Array<Types.Checkpoint>
) {
  function scale(value: number): number {
    if (checkpoints.length === 0) {
      return value;
    }

    const bisectedIndex = bisect(
      checkpoints,
      value,
      (checkpoint, value) => checkpoint.value - value
    );

    if (bisectedIndex > -1) {
      const checkpoint = checkpoints[bisectedIndex];
      return checkpoint.offset;
    }

    const index = -bisectedIndex - 1;

    if (index === 0) {
      return value;
    }

    const checkpoint = checkpoints[index - 1];

    if (checkpoint.type === "positive") {
      return checkpoint.offset + (value - checkpoint.value);
    } else {
      return checkpoint.offset;
    }
  }

  function invert(offset: number): number {
    if (checkpoints.length === 0) {
      return offset;
    }

    const bisectedIndex = bisect(
      checkpoints,
      offset,
      (checkpoint, offset, index) => checkpoint.offset - offset
    );

    if (bisectedIndex > -1) {
      const checkpoint = checkpoints[bisectedIndex];
      return checkpoint.value;
    }

    const index = -bisectedIndex - 1;

    if (index === 0) {
      return offset;
    }

    const checkpoint = checkpoints[index - 1];

    if (checkpoint.type === "positive") {
      return checkpoint.value + (offset - checkpoint.offset);
    } else {
      return checkpoint.value;
    }
  }

  scale.invert = invert;

  scale.ticks = () => [];

  return scale;
}



// WEBPACK FOOTER //
// ./src/components/Chart/discontinuousScale.js